<template>
  <div v-if="newVacationRequests.length || myVacationRequest.length" class="vacation_list">
    <div v-if="myVacationRequest.length" >
      <h3>Lista moich wniosków</h3>
      <table>
        <thead>
        <tr>
          <th>Czas urlopu</th>
          <th>Rodzaj</th>
          <th>Wysłano</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(vacation, i) in myVacationRequest" :key="i">
          <td>{{ vacation.day_start }} - {{ vacation.day_end }}</td>
          <td>{{ vacation.kind }}</td>
          <td>{{ vacation.created }}</td>
          <td v-if="vacation.day_start < dayAfterTommorow">
            <p style="color: red">Uwaga! Dodajesz urlop z mniej niż 2-dniowym wyprzedzeniem</p>
          </td>
          <td v-else></td>
          <td class="button_list">
            <button @click="removeVacation(vacation)" type="button" class="btn btn-orange btn-block">
              Anuluj
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="vacation_list" v-if="newVacationRequests.length">
      <h3>Lista wniosków do akceptacji</h3>
      <table>
        <thead>
        <tr>
          <th>Użytkownik</th>
          <th>Czas urlopu</th>
          <th>Rodzaj</th>
          <th>Wysłano</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(vacation, i) in newVacationRequests" :key="i">
          <td>{{ vacation.employee }}</td>
          <td>{{ vacation.day_start }} - {{ vacation.day_end }}</td>
          <td>{{ vacation.kind }}</td>
          <td>{{ vacation.created }}</td>
          <td class="button_list">
            <button @click="acceptVacation(vacation) " type="button"
                    class="btn btn-success btn-block">
              Zaakceptuj
            </button>
            <button @click="discardVacation(vacation)" type="button" class="btn btn-orange btn-block">Odrzuć
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>
import {backend} from "../../backend";

export default {
  name: "Vacation",
  data() {
    return {
      newVacationRequests: [],
      dayAfterTommorow: null
    };
  },
  props: {
    myVacationRequest: {
      type: Array,
    }
  },
  created() {
    this.getNewVacation(), this.getDayAfterTommorow(), this.$emit('refreshMyRequest')
  },
  methods: {
    getDayAfterTommorow() {
      var dAT = new Date()
      dAT.setDate(dAT.getDate() + 3)
      this.dayAfterTommorow = dAT.toISOString().split('T')[0]
    },
    getNewVacation() {
      return backend.getNewVacation()
          .then((response) => {
            this.newVacationRequests = response.data;
          })
          .catch(() => {
            this.$vs.notify({text: "Nie udało się pobrać listy nowych wniosków, color: 'danger'"});
          });
    },
    acceptVacation(data) {
      return backend.acceptVacation(data)
          .then((response) => {
            this.$vs.notify({
              text: response.data['detail'],
              color: 'blue'
            });
            this.getNewVacation();
            this.$emit('refreshCalendar')
            this.$emit('refreshVacationDays')
          })
    },
    discardVacation(data) {
      return backend.discardVacation(data)
          .then((response) => {
            this.$vs.notify({
              text: response.data['detail'],
              color: 'blue'
            });
            this.getNewVacation();
            this.$emit('refreshCalendar')
            this.$emit('refreshVacationDays')
            this.$emit('refreshMyRequest')
          });
    },
    removeVacation(data) {
      return backend.removeVacation(data)
          .then((response) => {
            this.$vs.notify({
              text: response.data['detail'],
              color: 'blue'
            });
            this.getNewVacation();
            this.$emit('refreshCalendar')
            this.$emit('refreshVacationDays')
            this.$emit('refreshMyRequest')
          })
    },
  }
}

</script>

<style scoped>
.vacation_list th {
  border-bottom: 1px solid black;
  padding: 5px;
  font-weight: bold;
}

.vacation_list {
  margin-bottom: 10px;
  margin-top: 10px;
  width: 100%;
  text-align: center;
}
.vacation_list table {
  width: 100%;
}
.vacation_list table p {
  margin: 0;
}
.vacation_list table tr:nth-child(even){
  color:blue;
}
.vacation_list table tr:hover{
  background-color: lightgray;
}
.vacation_list h3 {
  color: #235ba6
}
.vacation_list button {
  width: auto;
  display: inline;
  margin-top: 2px;
}

#empty_list {
  margin-bottom: 20px;
}
.button_list {
  float: right;
}

</style>


// WEBPACK FOOTER //
// Vacation.vue?7370d13e